import { mediaUrlForPlayback } from '@/lib/mediaUrls';

/**
 * Dual media layers for transition preview (outgoing under / beside incoming).
 * Styles are applied imperatively via applyTransitionPreviewFrame.
 */
export function DualTransitionPreview({
  blend,
  showOutgoing,
  fitMode = 'contain',
  outgoingVideoRef,
  outgoingImageRef,
  incomingVideoRef,
  incomingImageRef,
}) {
  if (!blend?.outgoing || !blend?.incoming) return null;

  const fitClass = fitMode === 'cover' ? 'object-cover' : 'object-contain';
  const outgoing = blend.outgoing;
  const incoming = blend.incoming;

  const layer = (clip, videoRef, imageRef, testId) => {
    if (clip?.videoUrl) {
      return (
        <video
          key={`tr-v-${clip.id}:${mediaUrlForPlayback(clip.videoUrl)}`}
          ref={videoRef}
          src={mediaUrlForPlayback(clip.videoUrl)}
          className={`absolute inset-0 w-full h-full ${fitClass}`}
          playsInline
          muted
          preload="auto"
          data-testid={testId}
        />
      );
    }
    if (clip?.imageUrl) {
      return (
        <img
          key={`tr-i-${clip.id}:${mediaUrlForPlayback(clip.imageUrl)}`}
          ref={imageRef}
          src={mediaUrlForPlayback(clip.imageUrl)}
          alt=""
          className={`absolute inset-0 w-full h-full ${fitClass}`}
          data-testid={testId}
        />
      );
    }
    return null;
  };

  return (
    <div
      className="absolute inset-0 z-[15] overflow-hidden pointer-events-none"
      data-testid="dual-transition-preview"
      aria-hidden
    >
      {showOutgoing ? layer(outgoing, outgoingVideoRef, outgoingImageRef, 'transition-outgoing-media') : null}
      {layer(incoming, incomingVideoRef, incomingImageRef, 'transition-incoming-media')}
    </div>
  );
}

export default DualTransitionPreview;
